// extracted by mini-css-extract-plugin
module.exports = {"noInternetConnection":"connection-off_noInternetConnection__dEtMT"};